import React, { useEffect, useState } from "react";
import { Field, Form, FormikProvider, useFormik } from "formik";
import {
    InputAdornment,
    TextField,
    makeStyles,
    useMediaQuery,
    useTheme,
} from "@material-ui/core";
import * as Yup from "yup";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import axios from "axios";
import { LOGIN } from "./../../../../env_config";
import { SetCookies } from "../../../../_metronic/_helpers/Cookies";
import { Link } from "react-router-dom";
import useValidatedImage from "../../../../hooks/useValidatedImage";
import { LOGO_BASE_URL, NODE_API_URL } from "../../../../env_config";
import { IoPersonOutline } from "react-icons/io5";
import { TbLockPassword } from "react-icons/tb";
import { useLocation, useHistory } from "react-router-dom";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { useDomain } from "../../../../contexts/DomainContext";
import { useLanguage } from "../../../../contexts/LanguageContext";

function DeleteAccount(props) {
    const language = useLanguage();
    const { origin } = useDomain();

    const theme = useTheme();
    const isXsDown = useMediaQuery(theme.breakpoints.down("xs"));

    const location = useLocation();
    const history = useHistory();

    const [showLoader, setShowLoader] = useState(false);

    const [bgLoader, setBgLoader] = useState(false);

    const logo = localStorage.getItem("logo");
    const backgroundImg = localStorage.getItem("backgroundImg");
    const backgroundColor = localStorage.getItem("backgroundColor");
    const nav_bar_color = localStorage.getItem("nav_bar_color");
    const nav_bar_font = localStorage.getItem("nav_bar_font");


    useEffect(() => {
        if (origin) {
            async function loadBgImg() {
                setBgLoader(true);
                try {
                    const res = await axios.get(
                        `${NODE_API_URL}/ccmode/get-ccmode-settings?origin=${origin}`,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                "Access-Control-Allow-Origin": "*",
                            },
                        }
                    );

                    // backend-level failure
                    if (res.data.success === false) {
                        return;
                    }

                    // success
                    localStorage.setItem("logo", res.data.data.Logo);
                    localStorage.setItem(
                        "backgroundImg",
                        res.data.data.background_image
                    );
                    localStorage.setItem(
                        "backgroundColor",
                        res.data.data.background_color
                    );
                    localStorage.setItem(
                        "nav_bar_color",
                        res.data.data.nav_bar_color
                    );
                    localStorage.setItem(
                        "nav_bar_font",
                        res.data.data.nav_bar_font
                    );
                } catch (err) {
                    console.log(err);
                } finally {
                    setBgLoader(false);
                }
            }

            loadBgImg();
        }
    }, [origin]);

    const remoteLogoImageUrl = `${LOGO_BASE_URL}/${encodeURIComponent(logo || "")}`;

    let defaultImageUrl = require("./Images/ccmode_login_bg2.png");

    const remoteBgImageUrl = `${LOGO_BASE_URL}/${encodeURIComponent(
        backgroundImg || ""
    )}`;

    const logoUrl = useValidatedImage({ remoteUrl: remoteLogoImageUrl });
    const bgUrl = useValidatedImage({
        remoteUrl: remoteBgImageUrl,
        defaultUrl: defaultImageUrl,
    });

    const useStyles = makeStyles((theme) => ({
        textField: {
            "& .MuiInputBase-input": {
                color: `#000 !important`,
            },
            backgroundColor: "#fff !important",
            "& .MuiInput-underline:before, & .MuiInput-underline:active:not(.Mui-focused):before, & .MuiInput-underline:hover:not(.Mui-disabled):before, & .MuiInput-underline:after": {
                borderBottom: "none !important",
            },
            "& input:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 1000px #ffffff inset !important",
                WebkitTextFillColor: `#000 !important`,
            },
            [theme.breakpoints.down("xs")]: {
                "& .MuiInputBase-input": {
                    fontSize: "16px !important",
                },
            },
        },
        loginContainer: {
            width: "100vw",
            height: "100vh",
            display: "flex",
            position: "relative",

            [theme.breakpoints.down("xs")]: {
                flexDirection: "column",
            },
        },
        bg: {
            backgroundImage: `url('${bgUrl.imageUrl}')`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            height: "100%",
            backgroundPosition: "center center",
            backgroundColor: backgroundColor || "#EEF0F8",
        },
        loginForm: {
            backgroundColor: nav_bar_color || "#F4F6FC",

            [theme.breakpoints.down("xs")]: {
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%,-50%)",
                width: "90%",
                height: "65%",
                borderRadius: "15px",
                backgroundColor: nav_bar_color || "rgba(244, 246, 252, 0.8)",
            },
        },
        newLoginBtn: {
            width: "10rem",
            height: "auto",
            position: "relative",
            display: "inline-block",
            cursor: "pointer",
            outline: "none",
            border: 0,
            verticalAlign: "middle",
            textDecoration: "none",
            background: "transparent",
            padding: 0,
            fontSize: "inherit",
            fontFamily: "inherit",

            "& .circle": {
                transition: "all 0.45s cubic-bezier(0.65, 0, 0.076, 1)",
                position: "relative",
                display: "block",
                margin: 0,
                width: "3rem",
                height: "3rem",
                background: backgroundColor || `linear-gradient(90deg, rgba(0,164,245,1) 0%, rgba(0,76,200,1) 100%) !important`,
                borderRadius: "1.625rem",
            },

            "& .circle .icon": {
                transition: "all 0.45s cubic-bezier(0.65, 0, 0.076, 1)",
                position: "absolute",
                top: 0,
                bottom: 0,
                margin: "auto",
                background: "#fff",
            },

            "& .circle .icon.arrow": {
                left: "0.625rem",
                width: "1.125rem",
                height: "0.125rem",
                background: "none",
            },

            "& .circle .icon.arrow::before": {
                content: '""',
                position: "absolute",
                top: "-0.25rem",
                right: "0.0625rem",
                width: "0.625rem",
                height: "0.625rem",
                borderTop: `0.125rem solid ${nav_bar_font || "#fff"}`,
                borderRight: `0.125rem solid ${nav_bar_font || "#fff"}`,
                transform: "rotate(45deg)",
            },

            "& .button_text": {
                transition: "all 0.45s cubic-bezier(0.65, 0, 0.076, 1)",
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                padding: "0.75rem 0",
                margin: "0 0 0 1rem",
                fontWeight: 500,
                lineHeight: 1.6,
                textAlign: "center",
                textTransform: "uppercase",
                color: nav_bar_font || "#616161",
            },

            "&:hover .circle": {
                width: "100%",
            },

            "&:hover .circle .icon.arrow": {
                background: nav_bar_font || "#fff",
                transform: "translate(1rem, 0)",
            },

            "&:hover .button_text": {
                color: nav_bar_font || "#fff",
            },

            [theme.breakpoints.down("xs")]: {
                "& .circle": {
                    width: "100%",
                },
                "& .circle .icon.arrow": {
                    background: nav_bar_font || "#fff",
                    transform: "translate(1rem, 0)",
                },

                "& .button_text": {
                    color: nav_bar_font || "#fff",
                },
            },
        },
    }));
    const classes = useStyles();

    const initialValues = {
        mail: "",
        password: "",
    };
    const LoginSchema = Yup.object().shape({
        mail: Yup.string()
            .email(language.CCMODE_VALIDATION_EMAIL_INVALID)
            .min(3, language.CCMODE_AUTH_MINIMUM_3_SYMBOLS)
            .max(50, language.CCMODE_AUTH_MAXIMUM_50_SYMBOLS)
            .required(
                language.CCMODE_AUTH_EMAIL_IS_REQUIRED
            ),
        password: Yup.string()
            .required(
                language.CCMODE_AUTH_PASSWORD_IS_REQUIRED
            )
            // .matches(
            //     /^(?=.*[a-z])/,
            //     "Password must contain at least one lowercase letter"
            // )
            // .matches(
            //     /^(?=.*[A-Z])/,
            //     "Password must contain at least one uppercase letter"
            // )
            // .matches(
            //     /^(?=.*[0-9])/,
            //     "Password must contain at least one number"
            // )
            // .matches(
            //     /^(?=.*[!@#$%^&*])/,
            //     "Password must contain at least one special character"
            // )
            // .min(8, "Password must be at least 8 characters long"),
    });

    const getInputClasses = (fieldname) => {
        if (formik.touched[fieldname] && formik.errors[fieldname]) {
            return "is-invalid";
        }

        if (formik.touched[fieldname] && !formik.errors[fieldname]) {
            return "is-valid";
        }

        return "";
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues,
        validationSchema: LoginSchema,
        onSubmit: async (values, { setStatus, setSubmitting }) => {
            setSubmitting(true);
            setStatus("");

            try {
                const res = await axios({
                    method: "POST",
                    url: `${NODE_API_URL}/ccmode/delete-website-ccmode-user`,
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Content-Type": "application/json",
                    },
                    data: {
                        ...values,
                        client: origin,
                    },
                });

                // Business‐logic error?
                if (res.data?.msg) {
                    setStatus(res.data.msg);
                    if(res.data.msg === "User Deleted Successfully!"){
                        setTimeout(() => {
                            history.push("/")
                        },3000)
                    }
                }
            } catch (error) {
                console.error(error);
                localStorage.removeItem("userData");
                setStatus(
                    language.CCMODE_AUTH_INVALID_CREDENTIALS
                );
            } finally {
                setSubmitting(false);
            }
        },
    });

    return (
        <>
            {showLoader || bgLoader ? (
                <LayoutSplashScreen />
            ) : (
                <div
                    className={`${classes.loginContainer} col-12 px-0`}
                    id="kt_login_signin_form"
                >
                    <div
                        className={`${classes.bg} ${
                            isXsDown ? "col-12" : "col-8"
                        }`}
                    ></div>
                    <div
                        className={`${classes.loginForm} ${
                            isXsDown ? "col-12" : "col-4"
                        } d-flex flex-center`}
                    >
                        <div className={`${isXsDown ? "col-12" : "col-10"}`}>
                            {logoUrl.isValid ? (
                                <div className="text-center mb-6">
                                    <img
                                        alt="Logo"
                                        src={logoUrl.imageUrl}
                                        height="76px"
                                        style={{
                                            maxWidth: "200px",
                                            objectFit: "contain",
                                        }}
                                    />
                                </div>
                            ) : (
                                ""
                            )}
                            <h6 className="text-center">{language.CCMODE_AUTH_DELETE_YOUR_ACCOUNT}</h6>
                            <FormikProvider value={formik}>
                                <Form
                                    onSubmit={formik.handleSubmit}
                                    className="form fv-plugins-bootstrap fv-plugins-framework"
                                    autoComplete="off"
                                >
                                    {formik.status ? (
                                        <div className="mb-10 login-alert alert alert-custom alert-light-danger alert-dismissible py-3">
                                            <div className="alert-text font-weight-bold">
                                                {formik.status}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className=""></div>
                                    )}
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="mb-5 login fv-plugins-icon-container">
                                                <Field
                                                    className={`form-control form-control-solid h-auto py-3 px-6 ${getInputClasses(
                                                        "mail"
                                                    )} ${classes.textField}`}
                                                    type="email"
                                                    name="mail"
                                                    placeholder="example@domain.com"
                                                    as={TextField}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment
                                                                position="start"
                                                                color="#fff"
                                                                style={{
                                                                    padding:
                                                                        "8px",
                                                                    margin: "0",
                                                                }}
                                                            >
                                                                <IoPersonOutline
                                                                    color="#0261CC"
                                                                    size={18}
                                                                />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                                {formik.errors.mail ? (
                                                    <div className="invalid-feedback">
                                                        {formik.errors.mail}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="mb-5 login fv-plugins-icon-container">
                                                <Field
                                                    className={`form-control form-control-solid h-auto py-3 px-6 ${getInputClasses(
                                                        "password"
                                                    )} ${classes.textField}`}
                                                    type="password"
                                                    name="password"
                                                    placeholder={language.CCMODE_AUTH_PASSWORD}
                                                    as={TextField}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment
                                                                position="start"
                                                                color="#fff"
                                                                style={{
                                                                    padding:
                                                                        "8px",
                                                                    margin: "0",
                                                                }}
                                                            >
                                                                <TbLockPassword
                                                                    color="#0261CC"
                                                                    size={18}
                                                                />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                                {formik.errors.password ? (
                                                    <div className="invalid-feedback">
                                                        {formik.errors.password}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 mt-2">
                                        <div className="text-center">
                                            <button
                                                className={`${classes.newLoginBtn} submit`}
                                                type="submit"
                                                disabled={formik.isSubmitting}
                                            >
                                                <span className={`button_text`}>
                                                    {language.CCMODE_AUTH_DELETE_ACCOUNT}
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </Form>
                            </FormikProvider>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default DeleteAccount;
